import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Phone, UserPlus } from 'lucide-react';
import { authAPI } from '../services/api';
import AuthShell from '../components/auth/AuthShell';
import { ErrorNote, Field, PrimaryButton, isValidPhone, normalizePhone } from '../components/auth/authUi';

const Login: React.FC = () => {
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [notMember, setNotMember] = useState(false);
    const navigate = useNavigate();

    const normalized = normalizePhone(phone);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setNotMember(false);

        if (!isValidPhone(normalized)) {
            setError('شماره موبایل باید ۱۱ رقم و با ۰۹ شروع شود');
            return;
        }

        setLoading(true);
        try {
            const response = await authAPI.requestOTP(normalized);
            localStorage.setItem('temp_phone', normalized);
            navigate('/verify-otp', { state: { phoneNumber: normalized, message: response.message } });
        } catch (err: any) {
            // interceptor پیام سرور را در err.message می‌گذارد؛ قبلاً این صفحه
            // دنبال err.response می‌گشت که هیچ‌وقت وجود نداشت و همیشه پیام عمومی
            // نشان می‌داد.
            const message = err?.message || 'ارسال کد تأیید ناموفق بود';
            if (/یافت نشد/.test(message)) setNotMember(true);
            setError(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell
            eyebrow="پنل مشتریان"
            title="خوش برگشتید"
            subtitle="شماره موبایلتان را وارد کنید تا کد ورود برایتان پیامک شود."
            footer={
                <>
                    حساب ندارید؟{' '}
                    <Link to="/register" className="font-semibold text-emerald-700 hover:text-emerald-900">
                        ثبت‌نام کنید
                    </Link>
                </>
            }
        >
            <form onSubmit={handleSubmit} noValidate className="space-y-5">
                <Field
                    label="شماره موبایل"
                    icon={<Phone className="h-4 w-4" />}
                    type="tel"
                    inputMode="numeric"
                    dir="ltr"
                    placeholder="09xx xxx xxxx"
                    className="text-left tracking-wider"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    autoComplete="tel"
                    autoFocus
                />

                {error && (
                    <ErrorNote>
                        {notMember ? 'این شماره هنوز ثبت‌نام نکرده است.' : error}
                    </ErrorNote>
                )}

                <PrimaryButton type="submit" loading={loading}>
                    دریافت کد ورود
                </PrimaryButton>

                {notMember && (
                    <Link
                        to="/register"
                        className="flex h-12 w-full items-center justify-center gap-2 rounded-2xl border-2 border-emerald-600 font-semibold text-emerald-700 transition hover:bg-emerald-50"
                    >
                        <UserPlus className="h-4 w-4" />
                        ساخت حساب با همین شماره
                    </Link>
                )}
            </form>
        </AuthShell>
    );
};

export default Login;
